import { getRouteUrl } from '@nackle/service-urls';

const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
	return url.toLowerCase().replace( '(env.)', env ? ( env === 'localhost' ? 'qa.' : env + '.' ) : '' );
}

// services
export const idURL = getRouteUrl( 'ID_PROVIDER' );
export const cmxURL = getRouteUrl( 'CMX_SERVICE_V2' );
export const navigationURL = getRouteUrl( 'NAVIGATION_SERVICE_V1' );
export const navigationURLv2 = getRouteUrl( 'NAVIGATION_SERVICE_V2' );
export const permissionsURL = getRouteUrl( 'PERMISSIONS_MANAGER_SERVICE' );

// hatches
export const TRANSLATIONS_EDITOR_HATCH_URL = getURL( 'https://(env.)translations-editor-hatch.biw.cloud' );
export const rosterGroupsHatchURL = getURL( 'https://(env.)roster-groups.biw.cloud' );